import { Toast } from "primereact/toast"
import { createContext, RefObject } from "react"

export const ToastContext = createContext<RefObject<Toast>|null>(null)


